export enum Path {
  ChangePassword = 'change-password',
  COMMUNITIES = 'communities',
  DASHBOARD = 'dashboard',
  DeleteAccount = 'delete-account',
  ForgotPassword = 'forgot-password',
  LOGIN = 'login',
  Profile = 'profile',
  QUESTIONNAIRE = 'questionnaire',
  REGISTRATION = 'registration',
  ResetPassword = 'reset-password',
  SERVICES = 'services',
  SUPPORT = 'support-centers',
}
